import React from "react";

import ExpenseForm from "./ExpenseForm";

import './NewExpense.css'

const NewExpense=(props)=>
{
    const saveExpenseDataHandler=(enteredExpenseData)=>
    {
        const expenseData={
            ...enteredExpenseData,
            id:Math.random().toString()
        }
        props.onaddExpense(expenseData);
         console.log(expenseData);
    }
    
    return(
        <div className="new-expense">
            <ExpenseForm onSaveExpense={saveExpenseDataHandler}/>
        </div>
    );
}


export default NewExpense;